import Vue from 'vue';
import router from '../router';
import {auth} from '@/firebase.js';

export default {
    state:{
      nombre:'',
      email:'',
      estatus:1,
      foto:'',
      id:null
    },
    mutations: {
      setUsuario(state,usuario){
        console.log(usuario);
        console.log('setUsuario');
        state.nombre=usuario.nombre;
        state.email=usuario.email;
        state.foto=usuario.foto;
        state.id=usuario.id;
        state.estatus=usuario.estatus;
      }
    },
    actions: {
      loginUsuario(context,usuario){
        context.commit('setUsuario',usuario);
        auth.signInWithCustomToken(usuario.token)
        .then(response=>{
          console.log(response);
          context.dispatch('getPerfil',usuario.id);
        })
        .catch(error=>{
          console.log(error);
        });
      },
      logoutUsuario(context){
        context.commit('setUsuario',{
          nombre:'',
          email:'',
          estatus:1,
          foto:'',
          id:null
        });
        localStorage.id_usuario_cliente_imperia=null;
        localStorage.id_cliente_imperia=null;
      },
    },
    getters: {  
      getUsuario(state){
        return state;
      }
    },
    
}


// WEBPACK FOOTER //
// ./src/modules/usuario.js